import { AppModule } from 'app/module';
import { EbCompanyBenefits } from 'module/ebCompanyBenefits/main';
import { mediaQueries } from 'util/mediaQueries';
import Template from './template.hbs';
import './styles.scss';

export class EbCategorizedBenefits extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            inner: '.m-ebCategorizedBenefits__inner',
            benefitsContainer: '.m-ebCategorizedBenefits__benefitsContainer',
            benefits: ['.m-ebCompanyBenefits'],
            benefitsTabs: ['.m-ebCategorizedBenefits__tabItem'],
            count: ['.m-ebCategorizedBenefits__mobileCategoriesCount'],
        };
    }

    domEvents() {
        if (this.dom.benefitsTabs) {
            for (let i = 0; i < this.dom.benefitsTabs.length; i += 1) {
                this.dom.benefitsTabs[i].addEventListener('click', () => this.switchTab(i));
            }
        }
    }

    ready() {
        if (mediaQueries.isMobile()) {
            for (let i = 0; i < this.benefits.length; i += 1) {
                this.dom.count[i].innerText = Object.keys(this.benefits[i].props.benefitItem).length;
            }
        }
    }

    switchTab(index) {
        if (!this.benefits[index].props.active) {
            for (let i = 0; i < this.benefits.length; i += 1) {
                if (this.benefits[i].props.active) {
                    this.benefits[i].updateProps({ active: false });
                }
            }
            this.benefits[index].updateProps({ active: true });
            const newProps = this.getPropsFromDom();
            this.updateProps(newProps, true);
        }
    }

    getPropsFromDom() {
        const ebCompanyBenefitsListProps = this.getBenefitsListProps();

        return {
            active: !!this.dom.inner,
            hasCategories: !!this.dom.benefitsContainer,
            benefits: ebCompanyBenefitsListProps,
        };
    }

    subs() {
        if (this.dom.benefits) {
            this.benefits = [];
            for (let i = 0; i < this.dom.benefits.length; i += 1) {
                this.benefits[i] = new EbCompanyBenefits(this.dom.benefits[i]);
            }
        }
    }

    getBenefitsListProps() {
        const ebCompanyBenefitsListProps = {};
        if (this.benefits) {
            for (let i = 0; i < this.dom.benefits.length; i += 1) {
                ebCompanyBenefitsListProps[i] = this.benefits[i].props;
            }
        }
        return ebCompanyBenefitsListProps;
    }
}
